/* eslint-disable react-hooks/exhaustive-deps */
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { Mixpanel } from '../config/Mixpanel'
import constants from '../utilities/constants'
import { useDispatch } from 'react-redux'
import useLearnTubeXTimer from '../hooks/useLearnTubeXTimer'
import { fetchRazorPayStatusForLearntubeX } from '../redux/razorPayLearntubeXSlice'
import axios from 'axios'
import { RAZORPAY_KEY } from '../config/api_config'
import useRazorpay from 'react-razorpay'
import { ClipLoader } from 'react-spinners'
import { setShowBanner } from '../redux/bottomIllustration'
import { toast } from 'react-toastify'
import { axiosNoAuth } from '../config/axiosInstance'

const LearnTubeXIllustartion = ({ sentinelRef, setIsAtEnd, authentication }) => {

    const { uid, email, userName, userPhone } = authentication
    const normalizedUserName = typeof userName === 'string' ? userName.trim() : ''
    const displayName = normalizedUserName && normalizedUserName.toLowerCase() !== 'unknown'
        ? normalizedUserName
        : 'Learner'

    const [loader, setLoader] = useState(false)

    const remaningTimer = useLearnTubeXTimer()
    const Razorpay = useRazorpay()
    const dispatch = useDispatch()

    const formatTime = (time) => {
        const seconds = Math.floor((time / 1000) % 60);
        const minutes = Math.floor((time / 1000 / 60) % 60);
        const hours = Math.floor((time / (1000 * 60 * 60)));

        return `${hours.toString().padStart(2, '0')}H :
                ${minutes.toString().padStart(2, '0')}M :
                ${seconds.toString().padStart(2, '0')}S`;
    }

    useEffect(() => {
        const sentinel = sentinelRef?.current;
        const observer = new IntersectionObserver((entries) => {
            // If the sentinel comes into view, setIsAtEnd to true
            if (entries[0].isIntersecting) {
                setIsAtEnd(true);
            } else {
                setIsAtEnd(false);
            }
        });

        if (sentinelRef?.current) {
            observer.observe(sentinelRef.current);
        }

        return () => {
            if (sentinel) {
                observer.unobserve(sentinel);
            }
        }
    }, [sentinelRef])

    const razorpayHandler = async (callback) => {
        try {
            const response = await axiosNoAuth.post(
                "https://xgfy-czuw-092q.m2.xano.io/api:IfQi_Nyx/razorpay_ninjacurate_payment/create_subscription_test",
                {
                    uid: uid,
                    plan_name: "LearnTubeX Unlimited (base personalised ltx)",
                    product_name: "LearnTubeX Unlimited (base personalised ltx)"
                }
            )
            const options = {
                key: RAZORPAY_KEY,
                currency: "INR",
                name: userName,
                description: "LearnTubeX Unlimited (base personalised ltx)",
                image: "",
                subscription_id: response.data?.subscription_id,
                modal: {
                    "ondismiss": function () {
                        callback()
                    }
                },
                handler: (res) => {
                    getOrderStatusSuccess(res)
                    callback();
                },
                prefill: {
                    name: userName,
                    email: email,
                    contact: userPhone,
                },
                notes: {
                    address: "Razorpay Corporate Office"
                },
                theme: {
                    color: "#26CBA1"
                }
            };
            const rzp1 = new Razorpay(options);
            rzp1.on("payment.failed", function (response) {
                callback()
                getOrderStatusFailed(response)
            });
            rzp1.open();
        } catch (error) {
            toast.error('Something Went Wrong! Try Again')
        } finally {
            callback()
        }
    }

    const getOrderStatusSuccess = async (response) => {

        await dispatch(fetchRazorPayStatusForLearntubeX({
            uuid: uid,
            payment_id: response?.razorpay_payment_id,
            subscription_id: response?.razorpay_subscription_id,
            isError: false,
            razorpay_signature: response?.razorpay_signature,
            errorObj: {}
        }))

        dispatch(setShowBanner(false))
    }

    const getOrderStatusFailed = async (response) => {
        dispatch(fetchRazorPayStatusForLearntubeX({
            uuid: uid,
            payment_id: response?.error?.metadata?.payment_id,
            subscription_id: response?.error?.metadata?.order_id,
            isError: true,
            razorpay_signature: "",
            errorObj: { ...response?.error }
        }))
    }



    return (

        <div className='flex flex-col items-center rounded-xl border border-[#7FC241] bg-gradient-to-br from-[#17395A] to-[#102D47] p-4 lg:items-start lg:p-6'>
            <div ref={sentinelRef} style={{ height: '1px' }}></div>
            <div className='lg:flex'>
                <div className='w-[195px] lg:w-[200px] h-full mx-auto flex-shrink-0'>
                    <img src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/successful-businessman-archive-career-growth_1.png?updatedAt=1686901583248" loading='lazy' alt="" className='w-full h-full object-center' />
                </div>
                <div className='w-full'>
                    <h2 className='text-center text-[32px] leading-8 lg:text-left'>{displayName}, Unlock <span className='font-bold text-[#54A3F5]'>Unlimited Learning</span> With LearnTubeX</h2>
                    <p className='text-sm w-[89%] lg:w-[95%] lg:text-base mx-auto lg:mx-0 text-center lg:text-left mt-2 mb-2 leading-[17px]'>Become the top 1% with access to unlimited personalised courses, unlimited doubt solving, voice & multi-language support, priority call support & a free CV + Linkedin review.</p>
                </div>
            </div>
            <div ref={sentinelRef} style={{ height: '1px' }}></div>
            <div className='w-full lg:flex lg:justify-between lg:items-center'>
                <div className=''>
                    {remaningTimer > 0 ? <div className='mx-auto'>
                        <p className='font-semibold text-sm lg:text-base mt-3 text-center lg:text-left'>Early-Bird Discount Till:</p>
                        <div className='text-[#E06064] max-w-[150px] text-center mx-auto font-extrabold border-2 border-[#E06064] px-1.5 py-1 rounded-lg mt-1'>{formatTime(remaningTimer)}</div>
                    </div> : null}
                    <p className='text-sm lg:text-base mt-2 text-center mb-5 lg:mb-0'>Only <span className='font-bold opacity-80'>₹399/Month</span> <span className='text-[#E06064]'>₹</span><span className='text-[#E06064] line-through'>3999</span></p>
                </div>
                <div className='lg:w-[330px] px-2 text-black flex justify-center items-center bg-[#7FC241] cursor-pointer h-[55px] mx-auto lg:mx-0 text-center py-3 rounded-xl font-semibold' onClick={() => {
                    Mixpanel.track(constants.Mixpanel.NORMAL_PAYMENT_BUTTON)
                    setLoader(true)
                    razorpayHandler(() => setLoader(false))
                }}>
                    {loader ? <ClipLoader size={20} /> : <p className='font-semibold '>Upgrade to LearnTubeX</p>}
                    {!loader && <FontAwesomeIcon icon={faArrowRight} className='text-xl font-bold ml-4 arrow-move' />}
                </div>
            </div>

        </div>
    )
}

export default LearnTubeXIllustartion
